export const useFeatureFlags = () => {
  const config = useRuntimeConfig();

  // NUXT_PUBLIC_INVOICE_FEATURE_GENERALLY_AVAILABLE
  const invoiceFeatureGenerallyAvailable = computed(
    () => config.public.invoiceFeatureAvailable !== false,
  );

  // NUXT_PUBLIC_INVOICE_FEATURE_STEP_IN_REGISTER_AVAILABLE
  const invoiceFeatureStepInRegisterAvailable = computed(
    () => config.public.invoiceFeatureStepInRegisterAvailable !== false,
  );

  return { invoiceFeatureGenerallyAvailable, invoiceFeatureStepInRegisterAvailable };
};
